import Card from '@mui/material/Card';
import {memo} from 'react';

const MUICard = (props: any): any => {
    const {children, className, onClick, ...rest} = props;
    return (
        <Card className={className} onClick={onClick} {...rest}>
            {children}
        </Card>
    );
};

export default memo(MUICard);
